export const mapFuelValue = (apiFuel) => {
  const fuelMappings = {
    DIESEL: 'Diesel',
    PETROL: 'Petrol',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    HYDROGEN: 'Hydrogen',
    NATURAL_GAS: 'Natural Gas',
    BI_FUEL: 'Bi Fuel',
  };

  return fuelMappings[apiFuel] || apiFuel;
};

export const mapTransmissionValue = (apiTransmission) => {
  const transmissionMappings = {
    MANUAL: 'Manual',
    AUTOMATIC: 'Automatic',
    SEMI_AUTOMATIC: 'Semi-Automatic',
    CVT: 'CVT',
    DUAL_CLUTCH: 'Dual-clutch',
  };

  return transmissionMappings[apiTransmission] || apiTransmission;
};

export const mapColourValue = (apiColour) => {
  const colourMappings = {
    RED: 'Red',
    BLUE: 'Blue',
    BLACK: 'Black',
    WHITE: 'White',
    SILVER: 'Silver',
    GREY: 'Grey',
    GREEN: 'Green',
    YELLOW: 'Yellow',
    ORANGE: 'Orange',
    PINK: 'Pink',
    PURPLE: 'Purple',
    BROWN: 'Brown',
    BEIGE: 'Beige',
    BRONZE: 'Bronze',
    GOLD: 'Gold',
    MULTICOLOUR: 'Multicolour',
  };

  return colourMappings[apiColour] || apiColour;
};

export const mapCarTypeValue = (apiCarType) => {
  const carTypeMappings = {
    PANEL_VAN: 'Van',
    HATCHBACK: 'Hatchback',
    SALOON: 'Saloon',
    ESTATE: 'Estate',
    SUV: 'SUV',
    COUPE: 'Coupe',
    CONVERTIBLE: 'Convertible',
    MPV: 'MPV',
    PICKUP: 'Pickup',
  };

  return carTypeMappings[apiCarType] || 'Other';
};

export const createSelectValue = (value) => ({
  value,
  label: value,
});

export const mapVehicleDataToForm = (apiData) => {
  const mappedData = {};

  if (apiData.makeId && apiData.makeName) {
    mappedData.makeSelect = {
      value: apiData.makeId,
      label: apiData.makeName,
    };
  }

  if (apiData.modelId && apiData.modelName) {
    mappedData.modelSelect = {
      value: apiData.modelId,
      label: apiData.modelName,
    };
  }

  if (apiData.fuel) {
    const fuelValue = mapFuelValue(apiData.fuel);
    mappedData.fuel = createSelectValue(fuelValue);
  }

  if (apiData.transmission) {
    const transmissionValue = mapTransmissionValue(apiData.transmission);
    mappedData.transmission = createSelectValue(transmissionValue);
  }

  if (apiData.colour) {
    const colorValue = mapColourValue(apiData.colour);
    mappedData.colour = createSelectValue(colorValue);
  }

  if (apiData.carType) {
    const bodyTypeValue = mapCarTypeValue(apiData.carType);
    mappedData.carType = createSelectValue(bodyTypeValue);
  }

  const directFields = [
    'derivative',
    'mileage',
    'year',
    'dateOfFirstRegistration',
    'engineSize',
    'vin',
    'previousKeepersInTotal',
    'mot',
    'doors',
  ];

  directFields.forEach((field) => {
    if (apiData[field] !== null && apiData[field] !== undefined) {
      mappedData[field] = apiData[field];
    }
  });

  return mappedData;
};

export const isValidVehicleData = (apiData) =>
  apiData && typeof apiData === 'object' && Object.keys(apiData).length > 0;

export const getSupportedFuelTypes = () => [
  'Diesel',
  'Petrol',
  'Electric',
  'Hybrid',
  'Hydrogen',
  'Natural Gas',
  'Bi Fuel',
];

export const getSupportedTransmissionTypes = () => [
  'Manual',
  'Automatic',
  'Semi-Automatic',
  'CVT',
  'Dual-clutch',
];

export const getSupportedBodyTypes = () => [
  'Van',
  'Hatchback',
  'Saloon',
  'Estate',
  'SUV',
  'Coupe',
  'Convertible',
  'MPV',
  'Pickup',
  'Other',
];
